import { MediaPackageCatalog } from '../components/MediaPackageCatalog';

/**
 * Transitions — .tfx packages carrying the `kernel-transition/1` cap. They live
 * in the SAME catalog as effects and are separated by caps alone; a package's
 * own `kind` field is an informational tag the engine does not dispatch on.
 *
 * <p>Not listed here, and not takeable-down anywhere: the six built-in
 * transitions (cross dissolve, fades, slides, zoom) are a compiled-in enum with
 * no catalog entry, and they are what a delisted package falls back to.
 */
export function TransitionCatalogPage() {
  return (
    <MediaPackageCatalog
      kind="TRANSITION"
      title="Transitions"
      emptyMessage="No transition packages match this filter."
    />
  );
}
